export const foodCollected = [
  {
    label: "Personal Care & Pet Food",
    "2016": 5,
    "2017": 4,
    "2018": 4,
  },
  {
    label: "Meat / Eggs",
    "2016": 2,
    "2017": 4,
    "2018": 4,
  },
  {
    label: "Dairy",
    "2016": 6,
    "2017": 7,
    "2018": 9,
  },
  {
    label: "Grains",
    "2016": 14,
    "2017": 12,
    "2018": 11,
  },
  {
    label: "Produce",
    "2016": 15,
    "2017": 23,
    "2018": 23,
  },
  {
    label: "Non-Perishables",
    "2016": 58,
    "2017": 50,
    "2018": 49,
  },
]
